export default "__VITE_ASSET__gG$GQj6S__"